(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["muwo-buying-options"] && !Shopify.designMode) return;
  try {
    class MuwoBuyingOptions extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-muwo-bo-data]');
      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.data = { options: {} };
      }

      this.idInput = this.querySelector('input[name="id"]');
      this.planInput = this.querySelector('[data-muwo-bo-plan]');
      this.planKeyInput = this.querySelector('[data-muwo-bo-plan-key]');
      this.planLabelInput = this.querySelector('[data-muwo-bo-plan-label]');
      this.qtyInput = this.querySelector('[data-muwo-bo-qty]');
      this.qtyDisplay = this.querySelector('[data-muwo-bo-qty-display]');
      this.decBtn = this.querySelector('[data-muwo-bo-qty-dec]');
      this.incBtn = this.querySelector('[data-muwo-bo-qty-inc]');
      this.rows = Array.from(this.querySelectorAll('[data-muwo-bo-option]'));
      this.cards = Array.from(this.querySelectorAll('[data-muwo-bo-card]'));
      this.atcButton = this.querySelector('add-to-cart-component button');
      this.setupShip();

      // Una sola SUSCRIPCIÓN de este producto en el carrito (Mati, 2026-10-28): si ya hay un plan
      // y se agrega otro (30 días → 90 días), el nuevo REEMPLAZA al anterior. La compra única y
      // una suscripción sí conviven. Se intercepta el click, se limpian las suscripciones viejas y
      // recién ahí se deja pasar el click original.
      if (this.atcButton) {
        this.atcButton.addEventListener('click', (e) => this.beforeAdd(e), true);
      }

      this.rows.forEach((row) =>
        row.addEventListener('click', () => this.selectOption(row.dataset.muwoBoOption))
      );

      // "Buy once for $X + shipping": elige la compra única y agrega con el mismo botón (mismo
      // formulario, mismas propiedades), así el carrito la ve como one-time. Si estaba en el plan
      // de 90 días, selectOption ya baja la cantidad de 3 a 1.
      this.buyOnce = this.querySelector('[data-muwo-bo-buyonce]');
      if (this.buyOnce) {
        this.buyOnce.addEventListener('click', () => {
          this.selectOption('onetime');
          if (this.atcButton && !this.atcButton.disabled) this.atcButton.click();
        });
      }

      if (this.decBtn) this.decBtn.addEventListener('click', () => this.stepQty(-1));
      if (this.incBtn) this.incBtn.addEventListener('click', () => this.stepQty(1));

      this.qty = 1;
      this.renderQty();
      this.selectOption(this.dataset.defaultOption);
    }

    selectOption(key) {
      const options = this.data.options || {};
      // The subscribe row is absent until the product has a real selling plan, so the
      // requested default can point at nothing. Leaving it unselected would submit
      // whatever variant id the markup happened to render with.
      if (!options[key]) key = Object.keys(options)[0];
      const option = options[key];
      if (!option) return;

      const previous = this.selected;
      this.selected = key;
      this.dataset.selected = key;

      // El plan de 90 días son SIEMPRE 3 botellas por entrega: la cantidad se fija en 3 y el
      // stepper se esconde (CSS por data-selected). Al salir de ese plan vuelve a 1; entre las
      // otras dos opciones se conserva lo que el visitante eligió.
      if (option.qty > 1) {
        this.qty = option.qty;
      } else if (previous && options[previous] && options[previous].qty > 1) {
        this.qty = 1;
      }
      this.renderQty();

      if (this.idInput) this.idInput.value = option.cartId;

      // El carrito reconoce "subscribe" / "onetime" (propiedad privada _muwo_plan); los dos
      // planes comparten la clave "subscribe" porque la lógica del carrito la decide el
      // selling plan real de la línea, no esta propiedad.
      if (this.planKeyInput) this.planKeyInput.value = option.key || key;
      if (this.planLabelInput) this.planLabelInput.value = option.label || '';

      if (this.planInput) {
        if (option.sellingPlan) {
          this.planInput.value = option.sellingPlan;
          this.planInput.disabled = false;
        } else {
          this.planInput.value = '';
          this.planInput.disabled = true;
        }
      }

      this.rows.forEach((row) => {
        const active = row.dataset.muwoBoOption === key;
        row.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      this.cards.forEach((card) => {
        card.classList.toggle('is-active', card.dataset.muwoBoCard === key);
      });

      if (this.atcButton) this.atcButton.disabled = !option.available;
    }

    // "Order now and it ships by Thursday, Oct 30": N días hábiles de procesamiento (Supliful) contados
    // desde el próximo día hábil, en hora de la costa este de EE.UU. Si hoy no es hábil o ya pasó la
    // hora de corte, el reloj arranca el siguiente día hábil. Salta fines de semana y feriados.
    setupShip() {
      const box = this.querySelector('[data-muwo-bo-ship]');
      const text = this.querySelector('[data-muwo-bo-ship-text]');
      if (!box || !text) return;
      try {
        const days = parseInt(box.dataset.days, 10) || 2;
        const cutoff = parseInt(box.dataset.cutoff, 10);
        const holidays = (box.dataset.holidays || '').split(/[\s,]+/).filter(Boolean);
        // Hora de pared en Nueva York, sin depender de la zona horaria del visitante.
        const ny = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const key = (d) =>
          d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
        const isBusiness = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !holidays.includes(key(d));
        const date = new Date(ny.getFullYear(), ny.getMonth(), ny.getDate());
        if (!isBusiness(date) || ny.getHours() >= (isNaN(cutoff) ? 14 : cutoff)) {
          do {
            date.setDate(date.getDate() + 1);
          } while (!isBusiness(date));
        }
        let left = days;
        while (left > 0) {
          date.setDate(date.getDate() + 1);
          if (isBusiness(date)) left -= 1;
        }
        const label = date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
        text.innerHTML = 'Order now and it ships by <strong></strong>';
        text.querySelector('strong').textContent = label;
      } catch (err) {
        // Se queda el texto fijo del HTML.
      }
    }

    async beforeAdd(e) {
      if (this._bypass) {
        this._bypass = false;
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      try {
        await this.clearOtherOptions();
      } catch (err) {
        // Si falla la limpieza igual se agrega: peor es no poder comprar.
      }
      this._bypass = true;
      this.atcButton.click();
    }

    async clearOtherOptions() {
      const option = (this.data.options || {})[this.selected];
      // Solo se reemplaza SUSCRIPCIÓN por SUSCRIPCIÓN (Mati, 2026-10-28): una compra única y una
      // suscripción conviven en el carrito, y comprar una vez nunca borra nada.
      if (!option || !option.sellingPlan) return;
      const wantPlan = String(option.sellingPlan);
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const stale = (cart.items || []).filter((item) => {
        if (String(item.variant_id) !== String(option.cartId)) return false;
        if (!item.selling_plan_allocation) return false; // la compra única se queda
        return String(item.selling_plan_allocation.selling_plan.id) !== wantPlan;
      });
      for (const item of stale) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      }
    }

    stepQty(delta) {
      this.qty = Math.max(1, (this.qty || 1) + delta);
      this.renderQty();
    }

    renderQty() {
      if (this.qtyInput) this.qtyInput.value = this.qty;
      if (this.qtyDisplay) this.qtyDisplay.textContent = this.qty;
      if (this.decBtn) this.decBtn.disabled = this.qty <= 1;
    }
  }

  if (!customElements.get('muwo-buying-options')) {
    customElements.define('muwo-buying-options', MuwoBuyingOptions);
  }

  /* Magnet hover del Add to Cart: alimenta las CSS vars que usan el ::before (hotspot
     radial que sigue al cursor) y el transform (el botón se inclina hacia el cursor,
     ~15% del offset, tope ±8px). El spring-back al salir lo hace la transition CSS.
     Escrituras rAF-throttled; no-op con prefers-reduced-motion o botón deshabilitado. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var PULL = 0.15;
    var MAX = 8;

    function attach(btn) {
      if (btn.dataset.muwoMagnet) return;
      btn.dataset.muwoMagnet = '1';
      var raf = null;
      var ev = null;

      function apply() {
        raf = null;
        if (!ev || btn.disabled) return;
        var r = btn.getBoundingClientRect();
        var mx = ((ev.clientX - r.left) / r.width) * 100;
        var my = ((ev.clientY - r.top) / r.height) * 100;
        var tx = Math.max(-MAX, Math.min(MAX, (ev.clientX - (r.left + r.width / 2)) * PULL));
        var ty = Math.max(-MAX, Math.min(MAX, (ev.clientY - (r.top + r.height / 2)) * PULL));
        btn.style.setProperty('--muwo-atc-mx', mx.toFixed(1) + '%');
        btn.style.setProperty('--muwo-atc-my', my.toFixed(1) + '%');
        btn.style.setProperty('--muwo-atc-tx', tx.toFixed(1) + 'px');
        btn.style.setProperty('--muwo-atc-ty', ty.toFixed(1) + 'px');
      }

      btn.addEventListener('pointermove', function (e) {
        ev = e;
        if (!raf) raf = window.requestAnimationFrame(apply);
      });

      btn.addEventListener('pointerleave', function () {
        ev = null;
        btn.style.setProperty('--muwo-atc-tx', '0px');
        btn.style.setProperty('--muwo-atc-ty', '0px');
      });
    }

    function init() {
      document.querySelectorAll('.muwo-bo__atc').forEach(attach);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
